import styles from '../../assets/styles/BusinessInsights/BusinessInsights.module.scss';
import { amountFormatter } from '../../utils/utils';
import { Charts, MimaText } from '../../components';
import { FaCalendar } from 'react-icons/fa';
import React from 'react';

const BusinessChartCard = ({ expenseAnalysis, expensePercentage, currencyCode }) => {
	return (
		<div className={styles.bi}>
			<MimaText variant="subtitle" mt={5} align="center">
				{`${currencyCode} Expense Analysis`}
			</MimaText>

			<div className={styles.bi__sideCards}>
				<div className={styles.bi__mainCards_b}>
					<div className={styles.card_top}>
						<div className={styles.card_top_icon}>
							<FaCalendar />
						</div>
						<MimaText variant="bodyBold" color="var(--color-primary)">
							Percentage Analysis
						</MimaText>
					</div>
					<div className={styles.card_pie}>
						<Charts data={expenseAnalysis} />
					</div>
					<div className={styles.card_bottom}>
						{expenseAnalysis.map((expense, index) => (
							<div key={index} className={styles.card_bottom_content}>
								{expense.name || 'Others'} - {expensePercentage(expense.value, currencyCode)}%
							</div>
						))}
					</div>
				</div>

				<div className={styles.bi__mainCards_b}>
					<div className={styles.card_top}>
						<div className={styles.card_top_icon}>
							<FaCalendar />
						</div>
						<MimaText variant="bodyBold" color="var(--color-primary)">
							Amount Analysis
						</MimaText>
					</div>

					<table>
						<tbody>
							{expenseAnalysis.map((value, index) => (
								<tr key={index}>
									<td> {value.name || 'Others'} </td>
									<td> {amountFormatter(currencyCode).format(value.value)} </td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default BusinessChartCard;
